import script from "./TaskStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskStep.vue?vue&type=script&lang=ts&setup=true"

import "./TaskStep.vue?vue&type=style&index=0&id=2b29f11e&lang=less"

const __exports__ = script;

export default __exports__